import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useMutation } from '@apollo/client'

import { abbreviateNumber, getCookie, setCookie } from '@shared/utils'
import { UPDATE_LIVE_BLOG_REACTION } from '@graphql/article/article.mutation'

const SocialShare = dynamic(() => import('@shared/components/socialShare'))

function LiveBlogReaction({ data, showShareOption, sSlug }) {
  const isAdded = useRef(getReaction())
  const [reaction, setReaction] = useState(data?.aReaction || [])
  const style = {
    btn: {
      border: '1px solid var(--theme-light)'
    },
    icon: {
      background: 'var(--theme-light)',
      width: 31,
      height: 31,
      lineHeight: '31px'
    }
  }

  const [updateReaction] = useMutation(UPDATE_LIVE_BLOG_REACTION)

  function handleReaction({ sUniCode, nCount }) {
    const alreadyAdded = isAdded.current?.includes(sUniCode)
    if (alreadyAdded) {
      isAdded.current = isAdded.current?.filter((r) => r !== sUniCode)
      setCookie({ cName: `reaction-${data?._id}`, cValue: isAdded.current, cDay: 3 })
    } else {
      isAdded.current = [...isAdded.current, sUniCode]
      setCookie({ cName: `reaction-${data?._id}`, cValue: isAdded.current, cDay: 3 })
    }
    updateReaction({ variables: { input: { _id: data?._id, aReaction: [{ sUniCode, nDifference: alreadyAdded ? -1 : 1 }] } } })
    setReaction(
      reaction?.map((r) => {
        if (r?.sUniCode === sUniCode) {
          return { ...r, nCount: alreadyAdded ? r?.nCount - 1 : r?.nCount + 1 }
        }
        return r
      })
    )
  }

  function getReaction() {
    const val = getCookie(`reaction-${data?._id}`)
    return val ? val?.split(',') : []
  }

  useEffect(() => {
    isAdded.current = getReaction()
    if (data?.aReaction?.length) {
      setReaction(
        data?.aReaction?.map((r) => {
          if (isAdded.current?.includes(r?.sUniCode)) {
            return {
              ...r,
              nCount: r.nCount + 1
            }
          } else return r
        })
      )
    }
  }, [])

  return (
    <div className="mt-2 mx-0 d-flex justify-content-between">
      <div className="d-flex align-items-center">
        {reaction?.map((r, i) => (
          <button
            key={`${data?._id}${i}`}
            suppressHydrationWarning
            style={{
              ...style.btn,
              background: isAdded.current?.includes(r?.sUniCode) ? 'var(--theme-light)' : 'transparent'
            }}
            className={`d-flex align-items-center rounded-pill ${i > 0 ? 'ms-1' : ''}`}
            onClick={() => handleReaction(r)}
          >
            <span style={style.icon} className="rounded-circle text-center">
              {r?.sUniCode}
            </span>
            <span className="ms-1 pe-2 text-dark small-text">{abbreviateNumber(r?.nCount)}</span>
          </button>
        ))}
      </div>
      {showShareOption && <SocialShare seoData={{ sSlug }} />}
    </div>
  )
}
LiveBlogReaction.propTypes = {
  data: PropTypes.object,
  showShareOption: PropTypes.bool,
  sSlug: PropTypes.string
}
export default LiveBlogReaction
